import Actions from '../actions';
import App from './AppStore';
import Trends from './TrendsStore';

export default class RootStore {
    // Create with either state (which would have a _clientConfig)
    // Or with no initial state, and a clientConfig
    constructor(state, clientConfig) {
        if (clientConfig) {
            // console.log('*** RootStore using constructor clientConfig', clientConfig);
        } else {
            if (state && state._clientConfig) {
                // console.log('*** RootStore using state.rootStore._clientConfig', state.rootStore._clientConfig);
                clientConfig = state._clientConfig;
            } else {
                console.error('RootStore() NO CLIENT CONFIG!');
            }
        }

        this._clientConfig = clientConfig;
        this.app = new App(state.app);
        this.trends = new Trends(state.trends);
    }
}



// WEBPACK FOOTER //
// ./src/common/stores/index.js